import React from "react";
import styled from "styled-components";

const CollaborationModels = ({ models }) => {
  return (
    <Collab>
      <ModelItemContentTitle>
        <h1>Collaboration Models</h1>
      </ModelItemContentTitle>
      <CollaborationMainContainer>
        {models.map((item) => (
          <CollaborationItemsContainer>
            <CollaborationItemsHeader>
              <p>{item.title}</p>
            </CollaborationItemsHeader>
            <CollaborationItemsContentContainer>
              <CollaborationItemSubtitle>
                Project Duration(month):
              </CollaborationItemSubtitle>
              <CollaborationItemsText>
                {item.projectDuration}
              </CollaborationItemsText>
              <hr></hr>
              <CollaborationItemSubtitle>
                Team Involvement:
              </CollaborationItemSubtitle>
              <CollaborationItemsText>
                {item.teamInvolvment}
              </CollaborationItemsText>
              <hr></hr>
              <CollaborationItemSubtitle>
                Best Scenario:
              </CollaborationItemSubtitle>
              <CollaborationItemsText>
                {item.bestScenario}
              </CollaborationItemsText>
              <hr></hr>
              <CollaborationItemSubtitle>
                Trail Period
              </CollaborationItemSubtitle>
              <CollaborationItemsText>
                {item.trailPeriod}
              </CollaborationItemsText>
              <hr></hr>
              <CollaborationItemSubtitle>Cost</CollaborationItemSubtitle>
              <CollaborationItemsText>{item.cost}</CollaborationItemsText>
            </CollaborationItemsContentContainer>
            <CollaborationButton>{item.button}</CollaborationButton>
          </CollaborationItemsContainer>
        ))}
      </CollaborationMainContainer>
    </Collab>
  );
};

const Collab = styled.div`
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  font-family: 'Archivo';
  @media (max-width: 970px) {
    width: 100%;
  }
`;

const CollaborationItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  min-width: 280px;
  margin-right: 25px;
  margin-bottom: 20px;
  border-radius: 5px;
  padding: 0.7rem;
  hr {
    margin: 0.9rem;
  }
  @media (max-width: 970px) {
    max-width: 100%;
  }
`;
const CollaborationItemsHeader = styled.div`
  padding: 1rem 0;
  margin: 0 1.5rem;
  border-bottom: 1px solid #ededed;
  padding-top: 2rem;
  & p {
    text-transform: uppercase;
    font-size: 0.9rem;
    line-height: 1;
    color: #0066b2;
    font-family: 'Archivo';
    font-weight: 750;
    margin: 0;
  }
`;

const CollaborationItemSubtitle = styled.p`
  font-size: 0.875rem;
  line-height: 0.9;
  padding-left: 25px;
  color: #3d3d3d;
  font-family: 'Archivo';
  font-weight: 400;
  margin: 0 0 0.25rem;
`;
const CollaborationItemsText = styled.p`
  font-size: 0.65rem;
  line-height: 1.2;
  padding-left: 25px;
  color: #3d3d3d;
  margin: 0;
  text-transform: uppercase;
  font-family: 'Archivo';
  font-weight: 800;
`;
const CollaborationItemsContentContainer = styled.div`
  padding-top: 3px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ededed;
  background: #fff;
  margin: 18px;
`;
const CollaborationMainContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  @media (max-width: 980px) {
    flex-direction: column;
    width: 100%;
  }
`;
const CollaborationButton = styled.button`
  will-change: background, color;
  -webkit-transition: background 0.3s, color 0.3s;
  transition: background 0.3s, color 0.3s;
  background: #0066b2;
  margin-top: auto;
  color: #fff;
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: 650;
  line-height: 1;
  display: block;
  text-align: center;
  height: 60px;
  border: 0.5px solid #f5f5f5;
  border-radius: 0;
  width: 100%;
  cursor: pointer;
  position: relative;
  opacity: inherit.8;
  &:hover {
    opacity: 1;
    color: white;
  }
`;

const ModelItemContentTitle = styled.div`
  font-family: 'Archivo';
  font-weight: 700;
  font-size: 1rem;
  max-width: 20px;
  text-transform: uppercase;
  line-height: 1.2;
  color: #3d3d3d;
  margin-bottom: 1rem;
  & h1 {
    font-size: inherit;
    font-weight: 850;
    margin-bottom: 0;
    line-height: inherit;
  }
`;

export default CollaborationModels;
